import React from 'react'
import { useMutation } from '@apollo/react-hooks'
import { Link } from "react-router-dom"
import gql from 'graphql-tag'
import { Pane } from 'evergreen-ui'
import _ from 'lodash'

const CREATE_TYPE = gql`
  mutation CreateType($data: String!) {
    createType(data: $data)
  }
`;
export default ({ types }) => {
  const [createType] = useMutation(CREATE_TYPE);
  return <Pane>
    {types.map(type => {
      const { data, _id } = type
      const { name } = JSON.parse(data)
      return <Pane key={_id}><Link to={'/types/' + _id}>
        {name}
      </Link></Pane>
    })}
    <Pane onClick={() => {
      const typeData = JSON.stringify({
        name: 'Test'
      })
      createType({ variables: { data: typeData }, refetchQueries: ['Types'] })
    }}>Nowy typ</Pane>
  </Pane>
}


